module.exports = __webpack_public_path__ + "static/subscribe-forms-aca8db9326d8b10c4c5ca87f1f131418.svg";